"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Caret = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _react = _interopRequireDefault(require("react"));

var _Theme = require("../../contexts/Theme");

var _CaretDownIcon = require("../Icons/CaretDownIcon");

var Caret = function Caret(_ref) {
  var disabled = _ref.disabled;

  var _useTheme = (0, _Theme.useTheme)(),
      colors = _useTheme.colors;

  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "jsx-2075650144"
  }, /*#__PURE__*/_react["default"].createElement(_CaretDownIcon.CaretDownIcon, {
    color: disabled ? colors.supportiveText : 'currentColor',
    size: 16
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2075650144"
  }, ["span.jsx-2075650144{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;pointer-events:none;position:absolute;right:8px;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);}"]));
};

exports.Caret = Caret;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDYXJldCIsImRpc2FibGVkIiwidXNlVGhlbWUiLCJjb2xvcnMiLCJzdXBwb3J0aXZlVGV4dCJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1NlbGVjdC9DYXJldC50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgdXNlVGhlbWUgfSBmcm9tICcuLi8uLi9jb250ZXh0cy9UaGVtZSc7XG5pbXBvcnQgeyBDYXJldERvd25JY29uIH0gZnJvbSAnLi4vSWNvbnMvQ2FyZXREb3duSWNvbic7XG5cbmludGVyZmFjZSBQcm9wcyB7XG4gIGRpc2FibGVkPzogYm9vbGVhbjtcbn1cblxuZXhwb3J0IGNvbnN0IENhcmV0OiBSZWFjdC5GQzxSZWFjdC5Qcm9wc1dpdGhDaGlsZHJlbjxQcm9wcz4+ID0gKHtcbiAgZGlzYWJsZWQsXG59KSA9PiB7XG4gIGNvbnN0IHsgY29sb3JzIH0gPSB1c2VUaGVtZSgpO1xuXG4gIHJldHVybiAoXG4gICAgPHNwYW4+XG4gICAgICA8Q2FyZXREb3duSWNvblxuICAgICAgICBjb2xvcj17ZGlzYWJsZWQgPyBjb2xvcnMuc3VwcG9ydGl2ZVRleHQgOiAnY3VycmVudENvbG9yJ31cbiAgICAgICAgc2l6ZT17MTZ9XG4gICAgICAvPlxuICAgICAgPHN0eWxlIGpzeD57YFxuICAgICAgICBzcGFuIHtcbiAgICAgICAgICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAgICAgICAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgICAgcmlnaHQ6IDhweDtcbiAgICAgICAgICB0b3A6IDUwJTtcbiAgICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoLTUwJSk7XG4gICAgICAgIH1cbiAgICAgIGB9PC9zdHlsZT5cbiAgICA8L3NwYW4+XG4gICk7XG59O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBOztBQUVBOztBQUNBOztBQU1PLElBQU1BLEtBQStDLEdBQUcsU0FBbERBLEtBQWtELE9BRXpEO0VBQUEsSUFESkMsUUFDSSxRQURKQSxRQUNJOztFQUNKLGdCQUFtQixJQUFBQyxlQUFBLEdBQW5CO0VBQUEsSUFBUUMsTUFBUixhQUFRQSxNQUFSOztFQUVBLG9CQUNFO0lBQUE7RUFBQSxnQkFDRSxnQ0FBQyw0QkFBRDtJQUNFLEtBQUssRUFBRUYsUUFBUSxHQUFHRSxNQUFNLENBQUNDLGNBQVYsR0FBMkIsY0FENUM7SUFFRSxJQUFJLEVBQUU7RUFGUixFQURGO0lBQUE7RUFBQSx5UkFERjtBQWtCRCxDQXZCTSJ9